import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight } from 'lucide-react';
import { loadProfile } from '../mock';

const Reflection = () => {
  const navigate = useNavigate();
  const profile = loadProfile();

  const handleContinue = () => {
    navigate('/dashboard');
  };

  if (!profile) {
    navigate('/values-profile');
    return null;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-mist via-mist-light to-fern">
      <header className="border-b border-calm-border bg-fern-card/80 backdrop-blur-sm">
        <div className="max-w-3xl mx-auto px-6 py-5">
          <div 
            className="text-2xl font-bold text-calm-text cursor-pointer" 
            style={{fontFamily: 'DM Serif Display, serif'}}
            onClick={() => navigate('/')}
          >
            OHMNAI
          </div>
        </div>
      </header>

      <div className="max-w-2xl mx-auto px-6 py-20">
        <div className="space-y-8 fade-in-up">
          <div className="space-y-4">
            <h1 className="text-4xl text-calm-text" style={{fontFamily: 'DM Serif Display, serif'}}>
              Thank you for sharing
            </h1>
            <p className="text-xl text-calm-text-secondary leading-relaxed">
              What you've shared helps OHMNAI understand what matters to you—not to optimize you, but to respect your values.
            </p>
          </div>

          <div className="bg-fern-card rounded-2xl p-8 border border-calm-border shadow-sm">
            <p className="text-lg text-forest leading-relaxed">
              You can now request action suggestions when you're ready. Or you can simply leave this here and return whenever you want.
            </p>
            <p className="text-lg text-forest leading-relaxed mt-4">
              There's no urgency. No pressure. No penalty for silence.
            </p>
          </div>

          <div className="pt-6">
            <Button
              onClick={handleContinue}
              className="bg-forest hover:bg-forest-dark text-white px-8 py-6 text-base rounded-xl transition-colors w-full md:w-auto"
            >
              Go to dashboard <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reflection;
